module.exports = __webpack_public_path__ + "static/media/podcast.3d027d8f.svg";